import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-stats',
  templateUrl: './reports-stats.component.html',
  styleUrls: ['./reports-stats.component.less']
})
export class ReportsStatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/stats/reports-stats/reports-stats.component.ts